import React, { useEffect,useState } from 'react'
import ApiUrl from '../../../../../configTools/apiUrl';
import PimaryInputSelect from '../../../../../components/forms/pimaryInputSelect';
import ListcollectionFunctions from '../../../../../functions/public/listcollection';

const ListCollection = ({colors,setColors}) => {
    const [colorsList,setColorsList] = useState([]);
    const [colorsFilter,setColorsFilter] = useState([]);
    const addColor = (e)=>{
      let intrustsArray = [];
      for (let index = 0; index < colors.length; index++) {
        const element = colors[index];
        intrustsArray.push(element);
      }
      intrustsArray.push(e);
      setColors(intrustsArray);
    }
    const removeColor = (e) =>{
        let newcolor = colors
      var intrustsArray =[];
      intrustsArray = newcolor.filter((item)=> {
        return item.value !== e.value
      })
      setColors(intrustsArray);
    }
    useEffect(()=>{
        fetch(ApiUrl.API_URL_ListCollection)
        .then(res=>res.json())
        .then(data =>{
            let colorListSend = [];
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              colorListSend.push({
                name: element.name,
                value: String(element.id)
              })
            }
            setColorsList(colorListSend);
            setColorsFilter(colorListSend);
        });
        if(colors.length === 0){
          ListcollectionFunctions.GetLatestUsed(setColors)
        }
    },[])
    useEffect(()=>{
        let newcolor = colorsList
        let filteredIntrusts = newcolor.filter((item)=> {
          return !colors.find((itemB)=> {
            return item.value === itemB.value;
          })
        })
        setColorsFilter(filteredIntrusts);
    },[colors])
  return (
    <>
          <label style={{
            fontSize:"12px"
          }}>Collections</label>
          <PimaryInputSelect setValue={addColor} Options={colorsFilter}/>
          <div className='register_intrustlist_container'>
            { 
              colors.map((item,index)=>{
                  return(
                    <div className='register_intrustlist_item' key={index}>
                      <div className='register_intrustlist_item_name'>
                        <p>{item.name}</p>
                      </div>
                      <div className='register_intrustlist_item_remove' onClick={()=>{removeColor(item)}}>X</div>
                    </div>
                  )
              })
            }
          </div>
    </>
  )
}

export default ListCollection
